import { render } from "./dashboard-card.vue?vue&type=template&id=1286381a"
import script from "./dashboard-card.vue?vue&type=script&lang=js"
export * from "./dashboard-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__